import { getApi, postApi, putApi } from "./apis";
const requestCache = new Map();

const cacheKey = (endpoint: string, params?: any) => {
  return `${endpoint}${params ? JSON.stringify(params) : ""}`;
};

const withCache = async (key: string, request: () => Promise<any>) => {
  if (requestCache.has(key)) {
    return requestCache.get(key);
  }

  const promise = request();
  requestCache.set(key, promise);

  try {
    const result = await promise;
    setTimeout(() => requestCache.delete(key), 2000);
    return result;
  } catch (error) {
    requestCache.delete(key);
    throw error;
  }
};
export const postNewUserData = async (data: any) => {
    try {
        return await postApi('User/create', data);
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Failed to post data : ${error.message}`);
        } else {
            throw new Error('Failed to post data : unknown error occured');
        }
    }
}
export const fetchUserRolesData = async() => {
  const endpoint = `masterdata/user-roles`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occurred");
    }
  });
}
export const fetchUserDetailsById =  async () => {
  const endpoint = `User/user-details`;
    return withCache(cacheKey(endpoint), async () => {
      try {
        return await getApi(endpoint);
      } catch (error: unknown) {
        if (error instanceof Error) {
          throw new Error(`Failed to fetch data: ${error.message}`);
        }
        throw new Error("Failed to fetch data: unknown error occurred");
      }
    });
}
export const editProfileDetails= async (data: any) => {
  try {
    return await putApi('User/update-user', data);
} catch (error: unknown) {
    if (error instanceof Error) {
        throw new Error(`Failed to post data : ${error.message}`);
    } else {
        throw new Error('Failed to post data : unknown error occured');
    }
}
};
